import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import {
  Button,
  Container,
  Group,
  PasswordInput,
  Space,
  Text,
  TextInput,
  Title,
  Box,
  List,
} from "@mantine/core";

import { useForm } from "@mantine/form";
import { validateEmail } from "../../../helpers/form.validators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { AccountCommander } from "../../../store/commanders/account.commander";
import ApplicationComander from "../../../store/commanders/application.comander";
import { GoogleButton } from "../../../components/google/google.button";
import navigationService from "../../../services/navigation/navigation.service";
import TermsCheckbox from "../../../components/common/termsAndConditions/termsAndConditions";
import { useTranslation } from "react-i18next";

export default function SignupPage() {
  const { t } = useTranslation();
  const appState = useSelector((state: any) => state.application);
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const id_organization = searchParams.get("orgId");
  const id_parent = searchParams.get("id");
  const coupon = searchParams.get("coupon");
  const id_sales = searchParams.get("id_sales");
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  useEffect(() => {
    if (!id_parent) return
    AccountCommander.cmd_get_email(id_parent);
  }, [id_parent]);

  const userData = useSelector((state: any) => state.account.userData);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
    },

    validate: {
      email: validateEmail,
      confirmPassword: (value, values) =>
        value !== values.password ? t("auth.passwordMismatch") : null,
    },
  });

  useEffect(() => {
    if (userData.username) {
      navigationService.navigate("/login");
    }
    if (userData.email) {
      form.setValues({ email: userData.email });
    }
  }, [userData?.email]);

  const onSubmit = (data) =>
    applicationComander.cmd_signup(data.email.toLowerCase(), data.password, {
      id_organization,
      id_parent,
      coupon,
      id_sales,
    });

  if (appState.authorise) {
    return <Redirect to={URL_PATHS.APP} />;
  }

  return (
    <div>
      <div className="auth-container-box">
        <div className="auth-split-layout">
          {/* Left side - Signup Form */}
          <Box className="auth-form-section">
            <Title order={1} align={"center"} className="auth-title">
              {t("auth.signup.title")}
            </Title>
            <Space h={"xl"}></Space>
            <GoogleButton
              text={t("auth.signup.google")}
              onClick={() => applicationComander.cmd_login_google()}
            />
            <Space h={"md"}></Space>
            <form
              onSubmit={form.onSubmit((values) => onSubmit(values))}
              className="u-w-100"
            >
              <TextInput
                mt="sm"
                required
                type="email"
                autoComplete="email"
                label={t("auth.email")}
                placeholder={t("auth.emailPlaceholder")}
                {...form.getInputProps("email")}
                disabled={id_parent != null}
              />

              <List size="xs" mt={"lg"} px={"md"} spacing={-2}>
                {t("auth.passwordRules")}
                <List.Item>{t("auth.passwordRuleLength")}</List.Item>
                <List.Item>{t("auth.passwordRuleUppercase")}</List.Item>
                <List.Item>{t("auth.passwordRuleLowercase")}</List.Item>
                <List.Item>{t("auth.passwordRuleNumber")}</List.Item>
              </List>

              <PasswordInput
                mt="sm"
                required
                autoComplete="new-password"
                label={t("auth.signup.password")}
                placeholder={t("auth.signup.passwordPlaceholder")}
                {...form.getInputProps("password")}
              />

              <PasswordInput
                mt="sm"
                required
                autoComplete="new-password"
                label={t("auth.signup.confirmPassword")}
                placeholder={t("auth.signup.confirmPasswordPlaceholder")}
                {...form.getInputProps("confirmPassword")}
              />
              <TermsCheckbox onChange={(checked) => setAcceptedTerms(checked)} />              
              <Group position="right" mt="md">
                <Button
                  size="lg"
                  type="submit"
                  className="u-w-100 auth-submit-button"
                  disabled={!acceptedTerms}
                >
                  {t("auth.signup.submit")}
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="u-w-100 mobile-auth-button"
                  onClick={() => history.push(URL_PATHS.LOGIN)}
                >
                  {t("auth.signup.login")}
                </Button>
              </Group>
            </form>
          </Box>

          {/* Right side - Login Prompt */}
          <Box className="auth-prompt-section">
            <div className="auth-prompt-content">
              <Text className="auth-prompt-title">
                {t("auth.signup.existingTitle")}
              </Text>
              <Text className="auth-prompt-description">
                {t("auth.signup.existingDescription")}
              </Text>
              <Button
                variant="outline"
                size="lg"
                className="auth-prompt-button"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                {t("auth.signup.login")}
              </Button>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
}
